import React from "react";

const DocumentTextOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
    <path d="M12 17.0625H6C3.2625 17.0625 1.6875 15.4875 1.6875 12.75V5.25C1.6875 2.5125 3.2625 0.9375 6 0.9375H12C14.7375 0.9375 16.3125 2.5125 16.3125 5.25V12.75C16.3125 15.4875 14.7375 17.0625 12 17.0625ZM6 2.0625C3.855 2.0625 2.8125 3.105 2.8125 5.25V12.75C2.8125 14.895 3.855 15.9375 6 15.9375H12C14.145 15.9375 15.1875 14.895 15.1875 12.75V5.25C15.1875 3.105 14.145 2.0625 12 2.0625H6Z" fill="#163B84"/>
    <path d="M13.875 6.9375H12.375C11.235 6.9375 10.3125 6.015 10.3125 4.875V3.375C10.3125 3.0675 10.5675 2.8125 10.875 2.8125C11.1825 2.8125 11.4375 3.0675 11.4375 3.375V4.875C11.4375 5.3925 11.8575 5.8125 12.375 5.8125H13.875C14.1825 5.8125 14.4375 6.0675 14.4375 6.375C14.4375 6.6825 14.1825 6.9375 13.875 6.9375Z" fill="#163B84"/>
    <path d="M9 10.3125H6C5.6925 10.3125 5.4375 10.0575 5.4375 9.75C5.4375 9.4425 5.6925 9.1875 6 9.1875H9C9.3075 9.1875 9.5625 9.4425 9.5625 9.75C9.5625 10.0575 9.3075 10.3125 9 10.3125Z" fill="#163B84"/>
    <path d="M12 13.3125H6C5.6925 13.3125 5.4375 13.0575 5.4375 12.75C5.4375 12.4425 5.6925 12.1875 6 12.1875H12C12.3075 12.1875 12.5625 12.4425 12.5625 12.75C12.5625 13.0575 12.3075 13.3125 12 13.3125Z" fill="#163B84"/>
    </g>
  </svg>
);

export default DocumentTextOutlineIcon;
